// extracted by mini-css-extract-plugin
export var errorsContainer = "_sr-1";
export var link = "_sr-0";